var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.561127 7.00008H15.4384C15.6653 7.00008 15.8704 7.13951 15.9573 7.35264C16.0441 7.56635 15.9961 7.81206 15.8356 7.97548L9.09917 14.8324C8.87975 15.0559 8.52491 15.0559 8.30548 14.8324C8.08606 14.609 8.08606 14.2479 8.30548 14.0245L14.083 8.14291H0.561698C0.25085 8.14291 0 7.88691 0 7.57149C0 7.25607 0.25085 7.00008 0.561127 7.00008Z",
    fill: "#020202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.697 0.152918C8.84042 0.152918 8.98442 0.208917 9.09413 0.320342L13.5854 4.89164C13.8049 5.11506 13.8049 5.4762 13.5854 5.69962C13.366 5.92304 13.0112 5.92304 12.7917 5.69962L8.30044 1.12832C8.08102 0.904898 8.08102 0.543764 8.30044 0.320342C8.40958 0.208917 8.55357 0.152918 8.697 0.152918Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngleRight);
export default __webpack_public_path__ + "static/media/arrow-angle-right.3f715f2cbbe9c545b58db559306b5586.svg";
export { ForwardRef as ReactComponent };